// src/services/SubscriptionService.js
import { auth } from '../firebase';

// Get the correct function URL based on environment
export const getFunctionURL = (functionName) => {
  if (process.env.REACT_APP_FUNCTIONS_URL) {
    return `${process.env.REACT_APP_FUNCTIONS_URL}/${functionName}`;
  }

  // For now, use the Firebase Functions URL since Cloud Run URLs aren't deployed yet
  return `https://us-central1-refounded-6a151.cloudfunctions.net/${functionName}`;
};

/**
 * Create a premium provider subscription
 */
export const createProviderSubscription = async (userId) => {
  try {
    const currentUser = auth.currentUser;
    if (!currentUser) throw new Error('User not authenticated');
    
    const idToken = await currentUser.getIdToken(true);
    
    console.log('Creating provider subscription for user:', userId);
    
    const response = await fetch(getFunctionURL('createProviderSubscription'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        idToken
      }),
    });

    const responseText = await response.text();
    console.log('Create subscription response:', response.status, responseText);
    
    let responseData;
    try {
      responseData = JSON.parse(responseText);
    } catch (e) {
      console.error('Failed to parse response:', responseText);
      throw new Error(`Server returned invalid response: ${responseText}`);
    }

    if (!response.ok) {
      console.error('Create subscription error response:', responseData);
      const errorMessage = responseData.details || responseData.error || 'Failed to create subscription';
      throw new Error(errorMessage);
    }

    return responseData;
  } catch (error) {
    console.error('Error creating subscription:', error);
    throw error;
  }
};

/**
 * Cancel provider subscription
 */
export const cancelProviderSubscription = async (userId) => {
  try {
    const currentUser = auth.currentUser;
    if (!currentUser) throw new Error('User not authenticated');
    
    const idToken = await currentUser.getIdToken(true);
    
    console.log('Canceling provider subscription for user:', userId);
    
    const response = await fetch(getFunctionURL('cancelProviderSubscription'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId,
        idToken
      }),
    });

    const responseText = await response.text();
    console.log('Cancel subscription response:', response.status, responseText);
    
    let responseData;
    try {
      responseData = JSON.parse(responseText);
    } catch (e) {
      console.error('Failed to parse response:', responseText);
      throw new Error(`Server returned invalid response: ${responseText}`);
    }

    if (!response.ok) {
      console.error('Cancel subscription error response:', responseData);
      const errorMessage = responseData.details || responseData.error || 'Failed to cancel subscription';
      throw new Error(errorMessage);
    }

    return responseData;
  } catch (error) {
    console.error('Error canceling subscription:', error);
    throw error;
  }
};

/**
 * Redirect to Stripe checkout for subscription
 */
export const redirectToSubscriptionCheckout = async (userId) => {
  try {
    const result = await createProviderSubscription(userId);
    
    if (result.sessionUrl) {
      // Redirect to Stripe Checkout
      window.location.href = result.sessionUrl;
    } else {
      throw new Error('No checkout URL received');
    }
  } catch (error) {
    console.error('Error redirecting to checkout:', error);
    throw error;
  }
};